import { TableCell, TableRow } from "style/components";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import JourneyGroupActionMenu from "./journey-group-action-menu";

const JourneyGroupsTableRow = ({ group = {} }) => {
  const [groupUsers, setGroupUsers] = useState([]);
  const { name = "" } = group;

  useEffect(() => {
    //api call to get users then set it as the default Group

    setGroupUsers([]);
  }, [setGroupUsers]);

  return (
    <TableRow>
      <TableCell>{name}</TableCell>
      <TableCell>
        <JourneyGroupActionMenu
          type="threeDotMenu"
          group={group}
          groupUsers={groupUsers}
        />
      </TableCell>
    </TableRow>
  );
};

JourneyGroupsTableRow.propTypes = {
  group: PropTypes.object.isRequired,
};

export default JourneyGroupsTableRow;
